import { SlotGameType1_2 } from "../SlotGameType1_2";
export class FairyMagicForestClassic2 extends SlotGameType1_2 {}